var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1967_15037)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 70,
    fill: "#D7F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6665 68.25C73.5325 68.25 76.6665 65.116 76.6665 61.25C76.6665 57.384 73.5325 54.25 69.6665 54.25C65.8005 54.25 62.6665 57.384 62.6665 61.25C62.6665 65.116 65.8005 68.25 69.6665 68.25Z",
    stroke: "#00424B",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6665 73.5C60.9165 73.5 55.6665 77.875 55.6665 82.25C55.6665 84.183 57.2335 85.75 59.1665 85.75H80.1665C82.0996 85.75 83.6665 84.183 83.6665 82.25C83.6665 77.875 78.4165 73.5 69.6665 73.5Z",
    stroke: "#00424B",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1967_15037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4619443faef97390fd927363ca5d53a2.svg";
export { ForwardRef as ReactComponent };